export const getRegions = () => {
  return ['CN'];
};
